import { render, staticRenderFns } from "./Wizardot6showprint.vue?vue&type=template&id=1a059b5d&scoped=true&"
import script from "./Wizardot6showprint.vue?vue&type=script&lang=js&"
export * from "./Wizardot6showprint.vue?vue&type=script&lang=js&"
import style0 from "./Wizardot6showprint.vue?vue&type=style&index=0&id=1a059b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a059b5d",
  null
  
)

export default component.exports